import ProductImporter from "components/Product/ProductImporter"
import { observer } from "mobx-react"
import React, { Component } from "react"
import { Button, Icon, Input, Segment } from "semantic-ui-react"
import shop from "shop/shop"
import "style/CheckoutPage.scss"
import moment from "moment"
import PrintCollectionButton from "components/PrintCollectionButton";

@observer
export default class CartExport extends Component {

  state = {
    showImport: false,
    listname: "",
  }

  setListname = ( e ) => {
    this.setState( { listname: e.currentTarget.value } )
  }

  createList = ( listname, products = false ) => {
    console.log( `creating`, listname )
    let list = shop.orderlist.list( listname )
    products && products.forEach( product => list.add( product ) )
    list.save()
    shop.toast( `${listname ? listname : "Merkliste"} ${translate( "gespeichert" )}`, "success", false, "bottom" )
    this.setState( { listname: "" } )
  }

  render() {
    const { listname } = this.state

    return <Segment className={"CartExport"}>
      <div className={"flex flex-column flex-row-ns"}>
        <Button onClick={shop.cart.export} basic><Icon name="download"/> {translate( "Exportieren" )}</Button>
        <ProductImporter/>
        {shop.config.checkoutFeatures.usePDFExport &&<div className="dib pr2">
          <PrintCollectionButton products={shop.cart.products}/>
        </div>}
        <div className="ml-auto">
          <div className="dib pr2">
            <Input
              placeholder={"Listename"}
              type={"text"} onChange={this.setListname} value={listname}/>
          </div>
          <Button
            onClick={() => {
              this.createList( listname || `Warenkorb-${moment().format( "YYYY-MM-DD HH:mm [Uhr]" )}`, shop.cart.products )
            }}
            basic>Als Merkliste speichern</Button>


        </div>
      </div>
    </Segment>
  }
}



// WEBPACK FOOTER //
// ./src/components/Cart/CartExport.js